export const getFileUploadAccept = (allowImage, allowVideo) => {
  if (allowImage && allowVideo) {
    return 'image/*,video/*'
  } else if (allowImage) {
    return 'image/*'
  } else if (allowVideo) {
    return 'video/*'
  }
}
